<template>
  <fragment>
    <app-panel title="Справочная информация" class="mb-4">
      <div :class="$style.items">
        <div v-for="item in information" :class="$style.item">
          <a :class="$style.button" :href="item.link" target="_blank">
            <app-icon :class="$style.icon" size="60" name="PdfIcon" />
            <div :class="$style.buttonText">
              <div :class="$style.buttonHeader">{{item.title}}</div>
              {{item.subtitle}}
            </div>
          </a>
        </div>
      </div>
    </app-panel>


<!--    <app-panel title="Видеоинструкции">-->
<!--      <div :class="$style.videos">-->
<!--        <video-player-->
<!--          v-for="(video, i) in videos"-->
<!--          :key="i"-->
<!--          :title="video.title"-->
<!--          :options="videoOptions(video.sources)"-->
<!--        />-->
<!--      </div>-->

      <!--      <div style="margin-top: 20px; text-align: center">-->
      <!--        <router-link :to="{name: 'changeBlog'}" tag="a">-->
      <!--          Изменения системы-->
      <!--        </router-link>-->
      <!--      </div>-->
    </app-panel>

  </fragment>
</template>

<script>
import VideoBlock  from "@/components/employee/reference-information/VideoBlock";
import VideoPlayer from "@/components/employee/reference-information/VideoPlayer";

export default {
  name:       "ReferenceInformation",
  components: {
    VideoBlock,
    VideoPlayer,
  },
  data() {
    return {
      information: [
        {
          title:    'Платежи',
          subtitle: 'Общая инструкция',
          link:     'https://api.myelsa.ru/storage/docs/manual_payments_2-12.pdf',
        },
        {
          title:    'Отопительный сезон',
          subtitle: 'Новая настройка в разделе "Тарифы"',
          link:     'https://api.myelsa.ru/storage/docs/manual_heating-season.pdf',
        },
        {
          title:    'Уведомления об ограничении',
          subtitle: 'Работа с должниками – новый раздел',
          link:     'https://api.myelsa.ru/storage/docs/manual_uoo.pdf',
        },
        {
          title:    'Готовые шаблоны',
          subtitle: 'Генерация квитанций',
          link:     'https://api.myelsa.ru/storage/docs/manual_text-templates_invoices.pdf',
        },
        {
          title:    'Перерасчет пеней',
          subtitle: 'Новый функционал',
          link:     'https://api.myelsa.ru/storage/docs/fines-recalculations-manual.pdf',
        },
        {
          title:    'Автозаполнение заявок',
          subtitle: 'Отправка обращений из блока «Счетчики»',
          link:     'https://api.myelsa.ru/storage/docs/manual_issues_20-11.pdf',
        },
        {
          title:    'Обновление тарифов',
          subtitle: 'Доработка дополнительных условий',
          link:     'https://api.myelsa.ru/storage/docs/manual_tariffs_20-11.pdf',
        },
        {
          title:    'Корректировка квитанций',
          subtitle: 'Отображение даты поверки счетчика',
          link:     'https://api.myelsa.ru/storage/docs/manual_date_meter_20-11.pdf',
        },
        {
          title:    'Массовые перерасчеты',
          subtitle: 'Порядок заполнения полей',
          link:     'https://api.myelsa.ru/storage/docs/manual_recalculations.pdf',
        },
        {
          title:    'Имена тарифов',
          subtitle: 'Функционал для ГИС ЖКХ',
          link:     'https://api.myelsa.ru/storage/docs/manual_tariffs_GIS.pdf',
        },
        {
          title:    'Приложение: ЛК Собственника',
          subtitle: 'Инструкция для жителей',
          link:     'https://api.myelsa.ru/storage/docs/manual_app.pdf',
        },
        // {
        //   title:    'Изменения в импорте',
        //   subtitle: '18.05.2021',
        //   link:     'https://api.myelsa.ru/storage/docs/manual_import-may2021.pdf',
        // },
        // {
        //   title:    'Презентация',
        //   subtitle: 'расчётная программа ЖКУ',
        //   link:     'https://api.myelsa.ru/storage/docs/elsa-presentation.pdf',
        // },
        {
          title:    'Краткая инструкция',
          subtitle: 'начало работы в расчётной программе',
          link:     'https://api.myelsa.ru/storage/docs/a4-manual.pdf',
        },
        {
          title:    'Обновление новостей',
          subtitle: '03.11.20',
          link:     'https://api.myelsa.ru/storage/docs/3-11-20-news-update.pdf',
        },
        {
          title:    'Обновление заявок',
          subtitle: '11.12.20',
          link:     'https://api.myelsa.ru/storage/docs/manual_issues.pdf',
        },
        {
          title:    'Шапка с адресом дома',
          subtitle: '26.12.20',
          link:     'https://api.myelsa.ru/storage/docs/manual_header.pdf',
        },
        {
          title:    'Проектные помещения',
          subtitle: 'Функционал для ГИС ЖКХ',
          link:     'https://api.myelsa.ru/storage/docs/manual_project_rooms.pdf',
        },
        // {
        //   title:    'Имена тарифов',
        //   subtitle: 'Функционал для ГИС ЖКХ',
        //   link:     'https://api.myelsa.ru/storage/docs/manual_tariffs_GIS.pdf',
        // },
        // {
        //   title:    'Массовые перерасчеты',
        //   subtitle: '26.12.20',
        //   link:     'https://api.myelsa.ru/storage/docs/manual_recalculations.pdf',
        // },
      ],
      videos: [
        {
          title:   'Вводная инструкция: знакомство с интерфейсом',
          sources: [
            { src: "https://api.myelsa.ru/storage/docs/video_06.webm", type: "video/webm" },
            { src: "https://api.myelsa.ru/storage/docs/video_06.mp4", type: "video/mp4" },
          ],
        },
        {
          title:   'Диспетчерская',
          sources: [
            { src: "https://testapi.myelsa.ru/storage/video/video_01.webm", type: "video/webm" },
            { src: "https://testapi.myelsa.ru/storage/video/video_01.mp4", type: "video/mp4" },
          ],
        },
        {
          title:   'Создание собственников',
          sources: [
            { src: "https://testapi.myelsa.ru/storage/video/video_02.webm", type: "video/webm" },
            { src: "https://testapi.myelsa.ru/storage/video/video_02.mp4", type: "video/mp4" },
          ],
        },
        {
          title:   'Тарифы',
          sources: [
            { src: "https://testapi.myelsa.ru/storage/video/video_03.webm", type: "video/webm" },
            { src: "https://testapi.myelsa.ru/storage/video/video_03.mp4", type: "video/mp4" },
          ],
        },
        {
          title:   'Размещение разных индивидуальных текстов в квитанциях',
          sources: [
            { src: "https://testapi.myelsa.ru/storage/video/video_05.webm", type: "video/webm" },
            { src: "https://testapi.myelsa.ru/storage/video/video_05.mp4", type: "video/mp4" },
          ],
        },
      ],
    };
  },
  methods:    {
    videoOptions( sources ) {
      return {
        controls: true,
        sources,
      };
    },
  },
};
</script>

<style lang="scss" module>
.items {
  margin: 16px -1px;
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
    margin: 0;
  }
}

.item {
  padding: 16px 16px;
  width: 50%;
  //flex: 1;
  //min-width: 400px;
  @media only screen and (max-width: 900px) {
    padding: 16px 0;
    width: 100%;
  }
}

.button {
  box-shadow: 0px 0px 9px 6px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  height: 137px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .2s ease-out;

  &:hover {
    box-shadow: 0px 0px 9px 6px rgba(0, 0, 0, 0.26);

    .icon {
      fill: #7367F0;
    }

    .buttonHeader {
      color: #7367F0;
    }
  }
}

.buttonText {
  color: #000000;
  font-size: 1.2rem;
  max-width: 70%;
  line-height: 1.4;
  transition: all .2s ease-out;
}

.buttonHeader {
  color: #403E91;
  font-size: 1.55em;
  line-height: 1;
  font-weight: bold;
  margin-bottom: 2px;
}

.icon {
  fill: #3E3F8F;
  margin-right: 7px;
  flex-shrink: 0;
  transition: all .2s ease-out;
}

.videos {
  display: flex;
  flex-wrap: wrap;
}

.video {
  max-width: 100%;
  //height: 400px;
}
</style>
